import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=6b4b1594&scoped=true"
import script from "./MenuEdit.vue?vue&type=script&lang=js"
export * from "./MenuEdit.vue?vue&type=script&lang=js"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=6b4b1594&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b1594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4b1594')) {
      api.createRecord('6b4b1594', component.options)
    } else {
      api.reload('6b4b1594', component.options)
    }
    module.hot.accept("./MenuEdit.vue?vue&type=template&id=6b4b1594&scoped=true", function () {
      api.rerender('6b4b1594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/MenuEdit.vue"
export default component.exports